export default __webpack_public_path__ + "static/media/link_explorer.032eae00.svg";